import React, { useState, useEffect } from "react";
import "./News.css";
import NewsTrackerTable from "./NewsTrackerTable";
import TopRightActionLinks from "../../TopRightActionLinks";
import EventsWrappers from "../../../wrappers/eventsWrappers";
import LatestNews from "../../../Dashboard/LatestNews";
import EventsWrappersGiq from "../../../wrappers/eventsWrappersGiq";
import * as FeatherIcon from "react-feather";

function News() {
  const [showConversationModal, setShowConversationModal] = useState(false);

  // ++++++++++++++++++++++++++
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("publishedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [filter, setFilter] = useState({
    title: "",
    types: "",
    regions: "",
    companies: "",
  });
  // ++++++++++++++++++++++++++

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="news_wrapper">
      <div className="news_position_headblock">
        <div className="news_position_subheadblock">
          <h5 className="news_position_head">News</h5>
          <p className="news_position_para">
            Real-time competitor movements, summaries, signals, and alerts.
          </p>
        </div>
        <div className="news_position_btn_block">
          <TopRightActionLinks actions={actions} />
        </div>
      </div>

      {/* <div className="quick_summary_wrapper">
        <div class="card_block positive">
          <h6 class="head green_head">Quick Summary:</h6>
          <ul class="list_card_ul">
            <li className="list_card_li ">
              What changed recently? — Siemens launched new smart infrastructure
              services, restructured 2 units, and won 3 key global contracts.
            </li>
            <li className="list_card_li ">
              Are there early indicators of strategy shifts? — Accelerated R&D
              in AI-powered industrial software and digital twin technology.
            </li>
            <li className="list_card_li ">
              What’s heating up? — Hiring in APAC, global press mentions, and
              customer momentum in sustainability initiatives.
            </li>
          </ul>
        </div>
      </div> */}

      {/* <div className="news_second_wrapper">
        <div className="row">
          <div className="col-md-6">
            <div className="news_second_subblock">
              <div className="news_second_subblock1">
                <h5 className="news_second_head">
                  Digital twin integration completed in building systems
                </h5>
                <p className="news_second_para">
                  Smart building offerings now include real-time digital
                  replicas.
                </p>
                <div className="comp_bottom_block">
                  <div className="comp_bottom_left">
                    <p className="comp_text_para">Digital Technology</p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>Digital Twin</i>
                    </p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>2025-07-18</i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="comp_bottom_right">
                <a href="#" className="comp_link_med">
                  Medium
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="news_second_subblock">
              <div className="news_second_subblock1">
                <h5 className="news_second_head">
                  Digital twin integration completed in building systems
                </h5>
                <p className="news_second_para">
                  Smart building offerings now include real-time digital
                  replicas.
                </p>
                <div className="comp_bottom_block">
                  <div className="comp_bottom_left">
                    <p className="comp_text_para">Digital Technology</p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>Digital Twin</i>
                    </p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>2025-07-18</i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="comp_bottom_right">
                <a href="#" className="comp_link_high">
                  High
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="news_second_subblock">
              <div className="news_second_subblock1">
                <h5 className="news_second_head">
                  Digital twin integration completed in building systems
                </h5>
                <p className="news_second_para">
                  Smart building offerings now include real-time digital
                  replicas.
                </p>
                <div className="comp_bottom_block">
                  <div className="comp_bottom_left">
                    <p className="comp_text_para">Digital Technology</p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>Digital Twin</i>
                    </p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>2025-07-18</i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="comp_bottom_right">
                <a href="#" className="comp_link_med">
                  Medium
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="news_second_subblock">
              <div className="news_second_subblock1">
                <h5 className="news_second_head">
                  Digital twin integration completed in building systems
                </h5>
                <p className="news_second_para">
                  Smart building offerings now include real-time digital
                  replicas.
                </p>
                <div className="comp_bottom_block">
                  <div className="comp_bottom_left">
                    <p className="comp_text_para">Digital Technology</p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>Digital Twin</i>
                    </p>
                    <p className="comp_dot">•</p>
                    <p className="comp_text_para">
                      <i>2025-07-18</i>
                    </p>
                  </div>
                </div>
              </div>
              <div className="comp_bottom_right">
                <a href="#" className="comp_link_high">
                  High
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <NewsTrackerTable /> */}

      <EventsWrappersGiq
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        perPage={perPage}
        sortField={sortField}
        setSortField={setSortField}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        filter={filter}
        setFilter={setFilter}
      />

      {/* <div className="news_custom_block">
        <div className="d-flex" style={{ padding: "12px" }}>
          <div className="icon_block">
            <FeatherIcon.Bookmark className="bookmar_icon" />
          </div>
          <div className="text_block">
            <div className="left_block_content">
              <div className="news_head_block">
                <h5 className="news_head">
                  Company Y Unveils Revolutionary Productivity Tool for Remote
                  Teams
                </h5>
                <p className="news_content">
                  Company Y's new tool enhances collaboration for remote teams
                  through innovative features...{" "}
                </p>
              </div>
              <div className="news_actions_btns">
                <p className="opp_green">Opportunity</p>
                <p className="opp_market">Market</p>
                <a href="#" className="edit_pen">
                  {" "}
                  <FeatherIcon.Edit2 className="top_icons" />{" "}
                </a>
              </div>
            </div>
            <div className="bottom_block">
              <div className="tag_left">
                <a href="#" className="tag_a">
                  {" "}
                  <img
                    src="/img/card_blue.png"
                    className="icon_tag"
                    alt="tags_icon"
                  />{" "}
                  Last Month
                </a>
                <a href="#" className="tag_a">
                  {" "}
                  <img
                    src="/img/cube_blue.png"
                    className="icon_tag"
                    alt="tags_icon"
                  />{" "}
                  Market
                </a>
                <a href="#" className="tag_a">
                  {" "}
                  <img
                    src="/img/search_list_blue.png"
                    className="icon_tag"
                    alt="tags_icon"
                  />{" "}
                  Product Launch
                </a>
                <a href="#" className="tag_a">
                  {" "}
                  <img
                    src="/img/watch_blue.png"
                    className="icon_tag"
                    alt="tags_icon"
                  />{" "}
                  Sustainable Practices
                </a>
              </div>
              <div className="show_right">
                <div className="so_what_block">
                  So what analysis{" "}
                  <img
                    src="/img/ai_converation_white.png"
                    className="icon_tag"
                    alt="tags_icon"
                  />
                </div>
                <div className="dropdown_below">More actions</div>
              </div>
            </div>
          </div>
        </div>
        <div className="show_more_signal_block">
          <p className="show_signal">
            <FeatherIcon.Plus className="plus_icon" /> Show more related signals
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default News;
